import { Component, ElementRef, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatRadioModule } from '@angular/material/radio';
import Swal from 'sweetalert2';
import { session } from '../../../environments/environment.session'
import { AnyCatcher } from 'rxjs/internal/AnyCatcher';
import { KlManageService } from '../service/kl-manage.service';
import { isJsxClosingElement } from 'typescript';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
@Component({
  selector: 'app-klm-manage',
  templateUrl: './klm-manage.component.html',
  styleUrls: ['./klm-manage.component.css']
})
export class KlmManageComponent {
  @ViewChild('popupTemplate') popupTemplate!: TemplateRef<any>;
  constructor(private dialog: MatDialog, private klmanageservice: KlManageService) { }
  list_flag: any = true
  page_flag: boolean = true;
  fourth: any;
  second: any;
  third: any;
  isLinear: any;
  first: any;
  create_flag: any = false
  Obj: any = {}
  datasource: any
  currentMonth!: number;
  currentYear!: number;
  daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  monthNames: any = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  calendarDates: Date[] = [];
  blockedDates: any = [];
  status: any = [{ code: "YES", value: "YES" }, { code: "NO", value: "NO" }]
  selectedDate!: any
  selectedOption!: string
  ebillUser: any;
  b_acct_id: any;
  displayedColumns: any = ['si_no', 'kalyan_mandap_name', 'address', 'capacity', 'booking_amt', 'status', 'action'];

  @ViewChild('paginator0', { static: false }) paginator0!: MatPaginator;
  @ViewChild('sortCol0', { static: false }) sortCol0!: MatSort;
  async ngOnInit() {
    this.ebillUser = JSON.parse(atob(session.erpUser));
    this.b_acct_id = this.ebillUser.b_acct_id;
    const today = new Date();
    this.currentMonth = today.getMonth();
    this.currentYear = today.getFullYear();
    await this.generateCalendar();
    await this.getdata()
  }

  table_data: any = []
  async getdata() {
    let obj: any = {}
    obj["b_acct_id"] = this.b_acct_id
    obj['status'] = ['ACTIVE', 'INACTIVE']
    let resp = await this.klmanageservice.getdata(JSON.stringify(obj))
    if (resp["error"] == false) {
      this.table_data = []
      this.table_data = resp.data

    }
    for (let i = 0; i < this.table_data.length; i++) {
      this.table_data[i]['new_index'] = i + 1
    }
    console.log(this.table_data)
    this.datasource = new MatTableDataSource(this.table_data)
    this.datasource.paginator = this.paginator0;
    this.datasource.sort = this.sortCol0;
  }


  async generateCalendar() {
    this.calendarDates = [];
    const firstDayOfMonth = new Date(this.currentYear, this.currentMonth, 1).getDay();
    const daysInMonth = new Date(this.currentYear, this.currentMonth + 1, 0).getDate();

    for (let i = 0; i < firstDayOfMonth; i++) {
      // this.calendarDates.push(null)
    }

    for (let i = 1; i <= daysInMonth; i++) {
      this.calendarDates.push(new Date(this.currentYear, this.currentMonth, i));
    }
    console.log(this.calendarDates)
  }

  prevMonth() {
    this.currentMonth--;
    if (this.currentMonth < 0) {
      this.currentMonth = 11;
      this.currentYear--;
    }
    this.generateCalendar();
  }

  nextMonth() {
    this.currentMonth++;
    if (this.currentMonth > 11) {
      this.currentMonth = 0;
      this.currentYear++;
    }
    this.generateCalendar();
  }

  availabilityStatus: string | null = null;
  isManageAvailabilityOpen = false;
  isAvailabilityOptionsOpen = false;
  manageDate: Date | null = null;


  // Use a Set to store blocked dates

  showManageButton(date: Date) {
    if (this.selectedDate === date) {
      this.manageDate = date;
    } else {
      this.selectedDate = date;
      this.manageDate = null;
    }
  }

  setAvailability(date: Date, status: string) {
    if (status === 'block') {
      if (this.isValidDate(date)) {
        this.blockedDates.push(date); // Add date to blockedDates
      } else {
        console.error('Invalid date:', date);
      }
    } else {
      this.blockedDates.pop(date); // Remove date from blockedDates
    }
    console.log(this.klmmangObj, 'before_block_Date')
    this.klmmangObj['blocked_date'] = this.blockedDates
    // this.blockedDates
    console.log(this.klmmangObj, 'after_block_Date')
    // Reset the selected and manage dates
    this.selectedDate = null;
    this.manageDate = null;
  }

  isBlocked(date: Date): boolean {
    return Array.from(this.blockedDates).some((d: any) => d.getTime() === date.getTime());
  }

  isValidDate(date: Date): boolean {
    return date instanceof Date && !isNaN(date.valueOf());
  }

  validateBlockedDates(): boolean {
    return this.blockedDates.size > 0 && Array.from(this.blockedDates).every((date: any) => this.isValidDate(date));
  }
  //////////////////////////////////////////////////////////////








  // showManageButton(date: Date) {
  //   if (this.selectedDate === date) {
  //     this.manageDate = date;
  //   } else {
  //     this.selectedDate = date;
  //     this.manageDate = null;
  //   }
  // }
  openManageAvailability(event: Event, date: any): void {
    event.stopPropagation();

    this.selectedDate = date;
    this.isManageAvailabilityOpen = true;
  }

  // setAvailability(date: Date, status: string) {
  //   // Your logic to set availability or block the date
  //   console.log(`Date: ${date}, Status: ${status}`);
  //   // Optionally reset the selected date
  //   this.selectedDate = null;
  //   this.manageDate = null;

  // }
  closeManageAvailability(): void {
    this.isManageAvailabilityOpen = false;
    this.selectedDate = null;
  }

  openAvailabilityOptions(status: string): void {
    this.availabilityStatus = status;
    this.isManageAvailabilityOpen = false;
    this.isAvailabilityOptionsOpen = true;
  }

  closeAvailabilityOptions(): void {
    this.isAvailabilityOptionsOpen = false;
    this.availabilityStatus = null;
  }


  saveStatus() {
    if (this.selectedOption === 'blocked') {
      this.blockedDates.push(this.selectedDate.toDateString());
    } else {
      this.blockedDates.pop(this.selectedDate.toDateString());
    }
    this.dialog.closeAll();
  }

  // isBlocked(date: Date): boolean {
  //   return this.blockedDates.has(date.toDateString());
  // }

  applyFilter(filterValue: string) {
    this.datasource.filter = filterValue.trim().toLowerCase();
  }
  open_create() {
    this.list_flag = false
    this.create_flag = true
  }

  export() {

  }

  back() {
  }
  arr: any = []
  number_of_hll() {
    this.arr = []

    for (let i = 0; i < Number(this.klmmangObj['no_of_hall']); i++) {
      this.arr.push({
        'hall_size': '',
        'room_type': '',
        'type': 'hall'
      })
    }
    console.log(this.arr);


  }
  room_arr: any = []
  number_of_room() {
    this.room_arr = []

    for (let i = 0; i < Number(this.klmmangObj['no_of_room']); i++) {
      this.room_arr.push({
        'hall_size': '',
        'room_type': '',
        'type': 'room'
      })
    }
    console.log(this.room_arr);


  }
  open_list() {
    this.list_flag = true
    this.create_flag = false
  }


  /////////////////////image upload /////////////////
  @ViewChild('uploaddocument', { static: false }) uploaddocument!: ElementRef;
  upload_image: any
  selectedFile2: any = []
  selected_file_name2: any = []
  upload_name_arr: any = []
  klmmangObj: any = {}
  onFileSelected(event: any) {
    const files = event.target.files;
    if (files.length > 6) {
      Swal.fire('Info', 'You can only upload up to 6 photos.', 'info');
      return;
    }

    for (let file of files) {
      if (file.size > 2 * 1024 * 1024) {
        Swal.fire('Info', 'Each file must be less than 2MB.', 'info');
        return;
      }
    }
    this.selected_file_name2 = []
    this.selectedFile2 = []
    this.upload_name_arr = []
    if (event.target.files.length == 0) {
      for (let i = 0; this.upload_name_arr.length; i++) {
        if (this.upload_name_arr[i] == this.selected_file_name2) {
          this.upload_name_arr.splice(i, 1)
          break
        }
      }
      this.selectedFile2 = {}
      this.selected_file_name2 = ""
      return
    }



    for (let i = 0; i < event.target.files.length; i++) {


      this.selectedFile2[i] = event.target.files[i];
      this.selected_file_name2[i] = event.target.files[i]['name']
    }

    //console.log(this.selectedFile2);


    if (this.upload_name_arr.includes(this.selected_file_name2) == true) {
      Swal.fire('Warning...', 'Same Name Document can not be Uploaded', 'warning')
      this.uploaddocument.nativeElement.value = null;
      return;
    } else {
      this.upload_name_arr = this.selected_file_name2
    }
    //console.log(this.upload_name_arr)
    let file_name = [];
    //console.log(this.selectedFile2);

    if (this.selectedFile2.length > 0) {
      for (let i = 0; i < this.selectedFile2.length; i++) {

        file_name[i] = this.selected_file_name2[i].split('.')
      }
    }

    // if (file_name.length < 2 || file_name[file_name.length - 1] != 'pdf') {
    //   this.selectedFile2 = null;
    //   // this.reset();
    //   this.uploaddocument.nativeElement.value = null;

    //   Swal.fire('Warning...', 'This File Not Supported , Please upload pdf format file', 'warning')
    //   return;
    // }

    this.klmmangObj['upload_doc'] = this.selected_file_name2
    // Handle file upload logic here
  }

  async submit() {
    console.log(this.klmmangObj, 'after_block_Date')
    let data = new FormData()
    let doc_type: any = []
    let doc_name: any = []
    if (this.selectedFile2.length > 0) {
      for (let i = 0; i < this.selectedFile2.length; i++) {

        data.append('file', this.selectedFile2[i])
      }
      doc_type.push('document' as never)
      doc_name.push(this.selected_file_name2 as never)
    }

    this.klmmangObj["b_acct_id"] = this.b_acct_id
    this.klmmangObj['doc_name'] = doc_name;
    this.klmmangObj['doc_type'] = doc_type;
    this.klmmangObj['user_id'] = this.ebillUser.user_id
    this.klmmangObj["room_arr"] = this.room_arr
    this.klmmangObj["hall_arr"] = this.arr
    this.klmmangObj["pricing"] = this.discount_arr
    this.klmmangObj['room_hll'] = [...this.room_arr, ...this.arr]
    console.log(this.klmmangObj)


    data.append('data', JSON.stringify(this.klmmangObj))
    console.log(this.klmmangObj)
    let resp = await this.klmanageservice.insertkalyanmandapdata(data)
    if (resp["error"] == false) {

      Swal.fire('Success', "Successfully Submitted", 'success')
      this.klmmangObj = {}
      this.room_arr = []
      this.arr = []
      this.discount_arr = []
      this.list_flag = true
      this.create_flag = false
    } else {
      Swal.fire('Error', "Server Side Error", 'error')

    }
  }

  discount_arr: any = [{ 'disct_type': null, 'dist_percentage': null, 'price_with_tax': null }]

  add() {
    console.log(this.discount_arr)
    this.discount_arr.push({
      'disct_type': null,
      'dist_percentage': null,
      'price_with_tax': null
    })
    console.log(this.discount_arr)


  }


  remove(index: number) {
    this.discount_arr.splice(index, 1);
  }

  data_by_id: any = []

  async view_detail(element: any) {

    let obj: any = {}
    obj["b_acct_id"] = this.b_acct_id
    obj["klm_id"] = element['klm_id']
    let resp: any = await this.klmanageservice.getklmdatabyid(JSON.stringify(obj))
    console.log(resp)
    if (resp["error"] == false) {
      this.data_by_id = []
      this.data_by_id = resp.data
    }
    console.log(this.data_by_id);



  }

  async open_application(element: any) {

  }

  toggleHoverText(event: Event) {
    const target = event.target as HTMLElement;
    const hoverText = target.nextElementSibling as HTMLElement;
    hoverText.classList.toggle('show');
  }


  async deactivate_klm(element: any) {

    let obj: any = {}
    obj = Object.assign({}, element)
    obj["b_acct_id"] = this.b_acct_id
    obj['status'] = 'INACTIVE'
    let resp = await this.klmanageservice.deactivateklm(obj)



    if (resp["error"] == false) {

      Swal.fire("Success", "SuccessFully Deactivated", 'success')
      await this.getdata()

    }
    else if (resp["error"] == 'CHECK') {
      Swal.fire({
        title: 'Oops',
        html: `<strong>${resp['data']}</strong><br><br>You can manage its availability so other persons can’t make booking on this Kalyan Mandap.`,

        imageUrl: '../../../assets/kalyan-mandap/deactivevate.png',
        imageWidth: 642, // Width in pixels
        imageHeight: 250, // Height in pixels
        confirmButtonColor: 'rgba(203, 29, 38, 1)',
        confirmButtonText: 'Back'
      });

    }
    else {
      Swal.fire("Error", "Server Side Error", 'error')
    }

  }
  async activate_klm(element: any) {

    let obj: any = {}
    obj = Object.assign({}, element)
    obj["b_acct_id"] = this.b_acct_id
    obj['status'] = 'ACTIVE'
    let resp = await this.klmanageservice.deactivateklm(obj)



    if (resp["error"] == false) {

      Swal.fire("Success", "SuccessFully Activated", 'success')
      await this.getdata()

    }
    else if (resp["error"] == 'CHECK') {
      Swal.fire({
        title: 'Oops',
        html: `<strong>${resp['data']}</strong><br><br>You can manage its availability so other persons can’t make booking on this Kalyan Mandap.`,

        imageUrl: '../../../assets/kalyan-mandap/deactivevate.png',
        imageWidth: 642, // Width in pixels
        imageHeight: 250, // Height in pixels
        confirmButtonColor: 'rgba(203, 29, 38, 1)',
        confirmButtonText: 'Back'
      });
      await this.getdata()
    }
    else {
      Swal.fire("Error", "Server Side Error", 'error')
    }

  }

  async View_details(element: any) {

  }

  async edit_Details(element: any) {
    console.log(element)
    this.list_flag = false
    this.create_flag = true
    this.update_flag = false
    this.klmmangObj = Object.assign({}, element)

    this.klmmangObj['b_acct_id'] = this.b_acct_id

    let resp = await this.klmanageservice.getklmdatabyid(JSON.stringify(this.klmmangObj))
    console.log(resp)
    if (resp["error"] == false) {

      this.klmmangObj = {
        ...this.klmmangObj, // Preserve existing properties
        ...resp['klm_price'][0] // Overwrite with new data
      }
      for (let i = 0; i < resp['room_dtls'].length; i++) {
        if (resp['room_dtls'][i]['type'] == "room") {
          this.room_arr.push(resp['room_dtls'][i])
        } else if (resp['room_dtls'][i]['type'] == "hall") {
          this.arr.push(resp['room_dtls'][i])
        }
      }
    }
    this.discount_arr = resp['klm_price']

    console.log(this.klmmangObj)
    console.log(this.arr)

    console.log(this.room_arr)

  }
  update_flag: any = true
  async manage_avilable(element: any) {

  }

  async update() {
    this.klmmangObj["b_acct_id"] = this.b_acct_id

    this.klmmangObj['user_id'] = this.ebillUser.user_id
    this.klmmangObj["room_arr"] = this.room_arr
    this.klmmangObj["hall_arr"] = this.arr
    this.klmmangObj["pricing"] = this.discount_arr
    this.klmmangObj['room_hll'] = [...this.room_arr, ...this.arr]
    console.log(this.klmmangObj)

    let resp = await this.klmanageservice.updateklmdetails(this.klmmangObj)
    if (resp['error'] == false) {
      Swal.fire('Success', "Successfully Updated", 'success')
      await this.getdata()
      this.create_flag = false
      this.update_flag = true
      this.list_flag = true

    }
    else if (resp["error"] == 'CHECK') {
      Swal.fire({
        title: 'Oops',
        html: `<strong>${resp['data']}</strong><br><br>You can manage its availability so other persons can’t make booking on this Kalyan Mandap.`,

        imageUrl: '../../../assets/kalyan-mandap/deactivevate.png',
        imageWidth: 642, // Width in pixels
        imageHeight: 250, // Height in pixels
        confirmButtonColor: 'rgba(203, 29, 38, 1)',
        confirmButtonText: 'Back'
      });

    }
    else{
      
      Swal.fire('Error',"Server Side Error",'error')
    }

  }


}
